export default __webpack_public_path__ + "static/media/D0410-time _ OBJECTS, clock, watch, reloj ACTIVITIES, time, tiempo.607f96cd.svg";